import { useTranslation } from 'react-i18next';
import { CN_PRODUCT, dataExpTagConfig } from '../const';
import { EXPOSURE_RECORD, sendClickTrack } from '@/tracks/25217';
import ArrowIcon from '@/images/icon/arrow-default.svg';
import { isNextClient } from '@/intl-jdi-common-ssr/utils/uaParser';
import { useEffect, useState } from 'react';
import { eventTrackingUtils } from '@/utils/eventTrack/eventTrackingUtils';
import RichComponent from '@/components/product/richComponent';

type TrackInfo = {
  /** 榜单id  */
  rankid: string;
  /** 榜单名称  */
  rankName: string;
  /** 榜单排名  */
  rankNum: string;

  mainskuid: string;
  skuid: string;
};

export default function BestSeller({
  bestSellerFloor,
  skuId,
}: {
  bestSellerFloor: any;
  skuId: string;
}) {
  const { t } = useTranslation();

  const [trackInfo, setTrackInfo] = useState<TrackInfo>({
    rankid: '',
    rankName: '',
    rankNum: '',
    mainskuid: '',
    skuid: '',
  });

  const gotoRankLandPage = () => {
    sendClickTrack.Productdetail_Bestseller_Click(trackInfo);
    location.href = bestSellerFloor?.destinationPageUrl;
  };

  useEffect(() => {
    const _trackInfo = {
      rankid: `${bestSellerFloor?.categoryId}`,
      rankName: bestSellerFloor?.categoryName,
      rankNum: `${bestSellerFloor?.rank}`,
      mainskuid: sessionStorage.getItem('initial_skuid') || skuId,
      skuid: skuId,
    };

    eventTrackingUtils.submitExp({
      event_id: EXPOSURE_RECORD.Productdetail_Bestseller_Expo,
      json_param: _trackInfo,
    });
    setTrackInfo(_trackInfo);
  }, [bestSellerFloor, skuId]);

  return (
    <div className={CN_PRODUCT('sku-best-seller')} onClick={gotoRankLandPage}>
      {/* <span className='rank-text'>{bestSellerFloor?.rankText}</span>
      <span className='category-text' onClick={gotoRankLandPage}>
        {t('dp.in', {
          cat: bestSellerFloor?.categoryName,
          interpolation: {
            escapeValue: false,
          },
        })}
      </span> */}
      <RichComponent className='rank-text' data={bestSellerFloor?.rankCategoryText} />
      <ArrowIcon />
    </div>
  );
}
